import {useState} from 'react'
import {StyledClip} from './PermissionSectionComponentStyle'
import Popover from '@mui/material/Popover'
import {useProjectDetails} from '../../../store/hooks/projectDetails'
import PropTypes from 'prop-types'
import {StyledIconButton} from '../../UserManagement/UserManagementStyle'
import MapRoundedIcon from '@mui/icons-material/MapRounded'
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded'
import FamilyRestroomRoundedIcon from '@mui/icons-material/FamilyRestroomRounded'
import {useConfig} from '../../../store/hooks/config'

const getFilterKeyByCategory = (filterConfig) => {
  const healthCategory = filterConfig?.data?.find((category) => category.id === '2')
  const healthFilterKeys = Object.fromEntries(healthCategory?.filters?.map((filter) => [filter.key, filter.name]) || [])
  const otherFilterKeys = Object.fromEntries(
    filterConfig?.data
      ?.filter((category) => category.id !== '2')
      ?.flatMap((category) => category.filters.map((filter) => [filter.key, filter.name])) || []
  )
  return {healthFilterKeys, otherFilterKeys}
}

const PermissionSectionComponent = ({selectedJurisdictionID, selectedFilterKeys}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [open, setOpen] = useState(false)
  const [selectedIcon, setSelectedIcon] = useState('')
  const {filterConfig} = useConfig()
  const {jurisdiction} = useProjectDetails()
  const {healthFilterKeys, otherFilterKeys} = getFilterKeyByCategory(filterConfig)
  const jurisdictionPermissionValues = selectedJurisdictionID?.map((stateID) => {
    const matchingJurisdiction = jurisdiction?.find((obj) => obj.STATE_ID === stateID)
    return matchingJurisdiction?.title
  })
  const healthFilters = selectedFilterKeys?.map((key) => healthFilterKeys[key]).filter(Boolean)
  const otherFilters = selectedFilterKeys?.map((key) => otherFilterKeys[key]).filter(Boolean)
  const handleNewClick = (event, iconName) => {
    setAnchorEl(event.currentTarget)
    setOpen(true)
    setSelectedIcon(iconName)
  }

  const handleClose = () => {
    setOpen(false)
    setSelectedIcon('')
  }

  // Function to get values based on selected icon
  const getValuesByIcon = () => {
    switch (selectedIcon) {
      case 'jurisdiction-permission':
        return jurisdictionPermissionValues
      case 'health-permission':
        return healthFilters
      case 'other-permission':
        return otherFilters
      default:
        return []
    }
  }

  return (
    <div style={{display: 'flex', justifyContent: 'space-between'}} aria-label='permission'>
      <StyledIconButton
        aria-label='jurisdiction-permission'
        data-testid='jurisdiction-permission'
        onClick={(event) => handleNewClick(event, 'jurisdiction-permission')}
      >
        <MapRoundedIcon variant='primaryIcon' />
      </StyledIconButton>
      <StyledIconButton
        data-testid='health-permission'
        aria-label='health-permission'
        onClick={(event) => handleNewClick(event, 'health-permission')}
      >
        <FavoriteRoundedIcon variant='primaryIcon' />
      </StyledIconButton>
      <StyledIconButton
        data-testid='other-permission'
        aria-label='other-permission'
        onClick={(event) => handleNewClick(event, 'other-permission')}
      >
        <FamilyRestroomRoundedIcon variant='primaryIcon' />
      </StyledIconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right'
        }}
        PaperProps={{
          sx: {
            borderRadius: '8px',
            padding: '4px',
            display: 'flex',
            justifyContent: 'center',
            margin: '4px',
            maxWidth: '450px',
            flexWrap: 'wrap'
          }
        }}
      >
        <div>
          {getValuesByIcon()?.map((value) => (
            <StyledClip variant='caption' key={value} label={value} />
          ))}
        </div>
      </Popover>
    </div>
  )
}

PermissionSectionComponent.propTypes = {
  selectedJurisdictionID: PropTypes.array,
  selectedFilterKeys: PropTypes.array
}
export default PermissionSectionComponent
